import { Complainant } from "../Model/Complainant";
import { v4 as v4uuid } from "uuid";
import { Query } from "../Model/Query";
import { getCurrentUser } from "./session";
import { Third } from "../Model/Third";
export class ComplainantService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(complainantId, diligenceId) {
        if (complainantId) {
            const response = await this.apiService.get('complainant/complainant_id/' + complainantId + '/diligence_id/' + diligenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener la victima`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ComplainantId`);
        }
    }
    async findByDiligenceNumber(diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('complainant/' + diligenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener la victima`);
            }
            const content = await response.json();
            return content;
        }
        else {
            throw new Error(`Error al obtener ComplainantId`);
        }
    }
    async findLostThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`complainant_lost/lostThirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async find(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`complainants?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(complainant => new Complainant(complainant).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveComplainant(complainant) {
        if (complainant) {
            const response = await this.apiService.post('complainant', complainant);
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener denunciante.`);
        }
    }
    async createComplainant(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const dateNow = new Date();
            const complainant = new Complainant({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                complainantThirId: thirdId,
                manifestation: " ",
                dateCreated: dateNow.toString(),
                collegiate: null,
                present: " ",
                delivery: " ",
                userId: getCurrentUser().id,
                representativeThirdId: null,
                third_name: null
            });
            const response = await this.apiService.post('complainant', complainant.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante Global de una diligencia`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante Global`);
        }
    }
    async deleteComplainantGlobal(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('complainants/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el denunciante.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante.`);
        }
    }
}
